import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import * as yup from 'yup';
import moment from 'moment';
import { useFormik } from 'formik';
import styled from 'styled-components';
import { Modal } from 'antd';
import { ThemeProps } from '../../../../genericComponents/globalStyles';
import headerBackground from '../../../../../assets/images/headerBackgroundYellow.png';
import { GET_SCHOOLS } from '../../../../../helpers/graphqlQueries';
import { useQuery } from '@apollo/client';
import Select from 'react-select';
import { Dropdown } from 'semantic-ui-react';

const schema = yup.object().shape({
  school: yup
    .string()
    .required()
    .max(200, 'School must be at most 200 characters'),
  city: yup
    .string()
    .required()
    .max(200, 'School address must be at most 200 characters'),
  majors: yup
    .string()
    .required()
    .max(200, 'Major must be at most 200 characters'),
  // honors: yup
  //   .string()
  //   .required()
  //   .max(200, 'Honors must be at most 200 characters'),
  degree_type: yup
    .string()
    .required()
    .max(200, 'Degree type must be at most 200 characters'),
  start_date: yup.date(),
  end_date: yup
    .date()
    .min(yup.ref('start_date'), "End Date can't be before Start Date"),
  is_present_date: yup.boolean(),
});

const degreesOptions = [
  {text: "MD", key: "MD", value: "MD"},
  {text: "DO", key: "DO", value: "DO"},
  {text: "MBA", key: "MBA", value: "MBA"},
  {text: "PhD", key: "PhD", value: "PhD"},
  {text: "MS", key: "MS", value: "MS"},
  {text: "Masters", key: "Masters", value: "Masters"},
  {text: "MPH", key: "MPH", value: "MPH"},
  {text: "MBBS", key: "MBBS", value: "MBBS"},
  {text: "US IMG", key: "US IMG", value: "US IMG"},
  {text: "IMG", key: "IMG", value: "IMG"},
  {text: "Canad-IMG", key: "Canad-IMG", value: "Canad-IMG"},
  {text: "Pre-Med", key: "Pre-Med", value: "Pre-Med"},
];

const initialValues = {
  school: '',
  city: '',
  degree_type: '',
  majors: '',
  // honors: '',
  end_date: new Date(),
  start_date: new Date(),
  is_present_date: false,
};

export default function SchoolModal(props) {
  const { isShow, onHide, addNewSchool, editSchool, deleteSchool, editValues } = props;
  const [schoolsList, setSchoolsList] = useState(null)

  useQuery(GET_SCHOOLS, {
    onCompleted: data =>{
      console.log(data)
      setSchoolsList(
        data.school_programs.map((school, index) => ({
          text: school.school_name,
          key: school.index,
          value: school.school_name,
        })),
      )
    }
  });

  useEffect(() => {
    if (isShow) {
      setFieldValue("start_date", new Date(moment(`01/${editValues?.start_date}`, 'DD/MM/YYYY',).format()))
      setFieldValue("end_date", new Date(moment(`01/${editValues?.end_date}`, 'DD/MM/YYYY',).format()))
      setFieldValue("school", editValues?.school || '')
      setFieldValue("city", editValues?.city || '')
      setFieldValue("degree_type", editValues?.degree_type[0] || '')
      setFieldValue("major", editValues?.major || '')
      setFieldValue("is_present_date", editValues?.is_present_date || false)
    }
  }, [isShow])

  const {
    errors,
    handleChange,
    handleSubmit,
    values,
    setFieldValue,
    touched,
    setFieldTouched,
  } = useFormik({
    initialValues: { ...initialValues },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  function onSubmit(values) {
    // const newHonors = [];
    // newHonors.push(values.honors);
    const newMajors = [];
    newMajors.push(values.majors);
    const newDegreeType = [];
    newDegreeType.push(values.degree_type)
    const newSchool = {
      id: '',
      subcollectionId: '',
      city: values.city,
      degree_type: newDegreeType,
      end_date: `${values.end_date.getMonth() + 1}/${values.end_date.getFullYear()}`,
      start_date: `${values.start_date.getMonth() + 1}/${values.start_date.getFullYear()}`,
      majors: newMajors,
      school: values.school,
      // honors: newHonors,
      is_present_date: values.is_present_date,
      subcollectionName: "schools"
    };
    if (editValues) {
      newSchool.subcollectionId = editValues.id;
      newSchool.id = editValues.id;
      editSchool(newSchool);
    } else {
      addNewSchool(newSchool);
    }
  }

  function onDelete(e) {
    e.preventDefault();
    deleteSchool({
      subcollectionId: editValues.id,
      subcollectionName: 'schools'
    });
  }

  return (
    <Modal footer={null} visible={isShow} width={900} onCancel={onHide}>
      <FormContainer onSubmit={handleSubmit}>
        <ModalHeader>
          <Titles fonstSize={"2em"}>{editValues ? 'Edit Education Experience' : 'Add Education Experience'}</Titles>
          <LineBottomYellow />
        </ModalHeader>
        <Container>
          <Titles>School</Titles>
          <CustomDropdown
            placeholder="Select School"
            fluid
            search
            selection
            options={schoolsList}
            onChange={(_, data) => setFieldValue('school', data.value)}
            onBlur={() => setFieldTouched('school', true)}
            value={values.school}
            name="school"
          />
          {touched.school && errors.school && (
            <ErrorText>{errors.school}</ErrorText>
          )}
          <Divider />
          <Titles>City, State</Titles>
          <Input
            name="city"
            type="text"
            placeholder="City, State"
            value={values.city}
            onChange={handleChange}
          />
          {touched.city && errors.city && (
            <ErrorText>{errors.city}</ErrorText>
          )}
          <Divider />
          <Row100>
            <Row50>
              <Titles>Start Date</Titles>
              <ReactDatePickerWraper
                name="start_date"
                showMonthYearPicker
                maxDate={new Date()}
                dateFormat="MM/yyyy"
                placeholderText="MM/yyyy"
                onChange={e => {
                  setFieldValue('start_date', e);
                }}
                selected={values.start_date}
              />
              {touched.start_date && errors.start_date && (
                <ErrorText>{errors.start_date}</ErrorText>
              )}
            </Row50>
            <Row50>
              <Titles>End Date</Titles>
              {values.is_present_date === false ?
                <ReactDatePickerWraper
                  name="end_date"
                  showMonthYearPicker
                  maxDate={new Date()}
                  dateFormat="MM/yyyy"
                  placeholderText="MM/yyyy"
                  onChange={e => {
                    if (
                      moment(e).isSame(moment(), 'year') &&
                      moment(e).isSame(moment(), 'month')
                    ) {
                      setFieldValue('end_date', moment().toDate());
                      return;
                    }
                    setFieldValue('end_date', e);
                    return;
                  }}
                  selected={values.end_date}
                />
                :
                <Titles><br/>Present</Titles>
              }
              {touched.end_date && errors.end_date && (
                <ErrorText>{errors.end_date}</ErrorText>
              )}
            </Row50>
          </Row100>
          <CheckLabel>
            <input
              onChange={handleChange}
              type="checkbox"
              name="is_present_date"
              checked={values.is_present_date === true ? true : false}
            />
            {' I am currently studing ?'}
          </CheckLabel>
          <Divider />
          <Titles>Majors</Titles>
          <Input
            name="majors"
            type="text"
            placeholder="Majors"
            value={values.majors}
            onChange={handleChange}
          />
          {touched.majors && errors.majors && (
            <ErrorText>{errors.majors}</ErrorText>
          )}
          <Divider />
          {/* <Titles>Honors</Titles>
          <Input
            name="honors"
            type="text"
            placeholder="Honors"
            value={values.honors}
            onChange={handleChange}
          />
          {touched.honors && errors.honors && (
            <ErrorText>{errors.honors}</ErrorText>
          )}
          <Divider /> */}
          <Titles>Degree type</Titles>
          <CustomDropdown
            placeholder="Select School"
            fluid
            search
            selection
            options={degreesOptions}
            onChange={(_, data) => setFieldValue('degree_type', data.value)}
            onBlur={() => setFieldTouched('degree_type', true)}
            value={values.degree_type}
            name="degree_type"
          />
          {touched.degree_type && errors.degree_type && (
            <ErrorText>{errors.degree_type}</ErrorText>
          )}
          <Divider />

          <Row100>
            {editValues ? (
              <>
                <Button type="button" onClick={onDelete}>Delete</Button>
                <Button
                  type="submit"
                  color="#FFF"
                  backgroundColor={ThemeProps.color.darkBlue}
                >
                  Save
                </Button>
              </>
            ) :
              <>
                <Button onClick={onHide} color={ThemeProps.color.darkBlue} >Cancel</Button>
                <Button
                  type="submit"
                  color="#FFF"
                  backgroundColor={ThemeProps.color.darkBlue}
                >
                  Save
                </Button>
              </>
            }
          </Row100>
        </Container>
      </FormContainer>
    </Modal>
  );
};

const ModalHeader = styled.div`
  width: 100%;
  padding: 20px 16%;
  margin-bottom: 24px;
  background-image: url(${headerBackground});
  background-position-x: -50px;
  background-color: #fefefe;
  border-bottom: 1px solid #ddd;
`;
const Container = styled.div`
  width: 100%;
  padding: 16px 16%;
`;
const LineBottomYellow = styled.div`
  width: 100%;
  border-bottom: 3px solid ${ThemeProps.color.gabaYellow};
  margin: 12px 0;
`;
const Divider = styled.div`
  width: 100%;
  border-bottom: 3px solid #eee;
  margin: 16px 0;
`;
const Input = styled.input`
  width: 100%;
  margin: 8px 0 0 0;
  font-size: 1.3em;
  padding: 10px 12px;
  border-radius: 4px;
  outline-color: #aaa;
  background-color: #fbfbfb;
  border: 2.5px solid #ddd;
`;
const Titles = styled.label`
  font-size: ${p => p.fonstSize || "1.4em"};
`;
const FormContainer = styled.form`
  display:flex;
  flex-direction: column;
  width: 100%;
`;
const ReactDatePickerWraper = styled(ReactDatePicker)`
  width: 100%;
  margin: 8px 0;
  border: 1px solid #ccc;
  font-size: 1.3em;
  padding: 8px 12px;
  background-color: #fbfbfb;
  outline-color: #aaa;
  border-radius: 4px;
`;
const Row100 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const Row50 = styled.div`
  width: 49%;
  display: flex;
  flex-direction: column;
`;
const Button = styled.button`
  width: 49%;
  padding: 14px 20px;
  font-size: 1.3em;
  margin-top: 8px;
  border-radius: 6px;
  background-color: ${p => p.backgroundColor};
  color: ${p => p.color};
  border: none;
  outline: none;
`;
const ErrorText = styled.p`
  color: #F00;
  margin: 8px 0;
`;
const CheckLabel = styled.label`
  font-size: 1.4em;
  margin-bottom: 12px;
`;
const SelectWrapper = styled(Select)`
  margin-top: 8px;
`;
const CustomDropdown = styled(Dropdown)`
  height: 40px;
  border: 1px solid lightgray;
  border-radius: 5px;
  margin-right: 15px;
  margin-top: 8px;
  padding-left: 10px;
  width: 100%;
  background-color: #fbfbfb;
  outline-color: #aaa;
`;